<template>
  <div class="form-group">
    <label for="client">
      {{ $t('users.worker') }}:
    </label>

    <div class="d-flex">
      <div :class="{ 'form-control': true, 'is-select': true }">
        <v-select
          :options="workers"
          v-model="workerId"
          :reduce="worker => worker.id"
          :filterBy="filterByForWorkers"
          :placeholder="$t('users.selectWorker')"
          label="name"
          :clearable="false">
          <template slot="no-options">
            {{ $t('users.noUsersMatchingPhrase') }}&hellip;
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>
      </div>

      <d-button
        v-if="workerId !== previousWorkerId"
        class="ml-2"
        theme="success"
        outline
        :disabled="assignInProgress"
        @click.prevent="assignOrder">
        <template v-if="!assignInProgress">{{ $t('users.assign') }}</template>
        <template v-else>
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </template>
      </d-button>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'order-select-worker',
  props: [
    'currentWorkerId',
    'orderId'
  ],
  computed: {
    userIsWorker () {
      return this.$store.getters.getUserType === 'worker';
    }
  },
  data () {
    return {
      assignInProgress: false,
      loadWorkersError: false,
      previousWorkerId: null,
      workerId: null,
      workers: []
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/users/items',
      outputKey: 'workers',
      errorKey: 'loadWorkersError',
      params: {
        return: 'get',
        where: {
          type: ['admin', 'worker']
        }
      },
      successAction: () => {
        Vue.set(this, 'workerId', this.currentWorkerId);
        Vue.set(this, 'previousWorkerId', this.currentWorkerId);

        if (this.userIsWorker) {
          let currentUserID = this.$store.getters.getUserID;
          this.workers = this.workers.filter(worker => worker.id === currentUserID || worker.id === this.currentWorkerId);
        }
      }
    });
  },
  methods: {
    filterByForWorkers (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    assignOrder () {
      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/orders/change-user/' + this.orderId,
        formData: {
          user_id: this.workerId
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.saveChangesErrorText'),
        successAction: (response) => {
          this.assignInProgress = false;

          if (response.success) {
            this.previousWorkerId = this.workerId;

            Vue.swal({
              title: this.$t('users.workerAssingSuccessTitle'),
              html: this.$t('users.workerAssingSuccessText'),
              type: 'success',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });
          } else {
            Vue.swal({
              title: this.$t('users.workerAssingErrorTitle'),
              html: this.$t('users.workerAssingErrorText'),
              type: 'error',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });
          }
        },
        failAction: () => {
          this.assignInProgress = false;
        }
      });
    }
  }
}
</script>
